<div class="footer">
  <div class="row">
    <div class="col-12 signature">
      Powered by Lendfinity
    </div>
  </div>
</div>
